import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import jaCommon from './locales/ja/common.json'
import jaHome from './locales/ja/home.json'
import jaProfile from './locales/ja/profile.json'
import jaProducts from './locales/ja/products.json'
import jaTalks from './locales/ja/talks.json'
import jaBlog from './locales/ja/blog.json'
import jaTech from './locales/ja/tech.json'

import enCommon from './locales/en/common.json'
import enHome from './locales/en/home.json'
import enProfile from './locales/en/profile.json'
import enProducts from './locales/en/products.json'
import enTalks from './locales/en/talks.json'
import enBlog from './locales/en/blog.json'
import enTech from './locales/en/tech.json'

export const resources = {
  ja: {
    common: jaCommon,
    home: jaHome,
    profile: jaProfile,
    products: jaProducts,
    talks: jaTalks,
    blog: jaBlog,
    tech: jaTech,
  },
  en: {
    common: enCommon,
    home: enHome,
    profile: enProfile,
    products: enProducts,
    talks: enTalks,
    blog: enBlog,
    tech: enTech,
  },
} as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    defaultNS: 'common',
    ns: ['common', 'home', 'profile', 'products', 'talks', 'blog', 'tech'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
